<template>
      <NavBar />
      <div class="row">
        <div class="col-md-6 form">
          <form @submit.prevent="submitForm" class="mb-3" id="form-mb3">
            <div class="form-name">
              <label for="name" class="form-label">Name</label>
              <input type="text" value="Name" class="form-control name-input" id="name" v-model="contact.name" required>
            </div>
            <div class="form-email">
              <label for="email" class="form-label">Email</label>
              <input type="email" value="Email" class="form-control email-input" id="email" v-model="contact.email" required>
            </div>
            <div class="form-message">
              <label for="message" class="form-label">Message</label>
              <textarea class="form-control message-input" id="message" v-model="contact.message" rows="3" required></textarea>
            </div>
            <button type="submit" class="btn btn-primary form-submit">Send Message</button>
          </form>
        </div>
        <div class="col-md-6" id="socials">
          <div class="social-links">
            <h3>Social Media</h3>
            <a href="https://www.linkedin.com/in/ashhadsyed/" target="_blank" class="btn btn-outline-info m-1"><i class="fab fa-linkedin"></i> LinkedIn</a>
            <a href="https://github.com/waquas9248" target="_blank" class="btn btn-outline-secondary m-1"><i class="fab fa-github"></i> GitHub</a>
            <a href="https://x.com/SyedAshhad7419" target="_blank" class="btn btn-outline-primary m-1"><i class="fab fa-twitter"></i> Twitter</a>
          </div>
          <div class="social-contact">
            <h3>Contact Information</h3>
            <p><strong>Email:</strong> ashhadwsyed@gmail.com</p>
          </div>
        </div>
      </div>
</template>
  
<script>
    export default {
    name: 'ContactPage',
    data() {
        return {
        contact: {
            name: '',
            email: '',
            message: ''
        }
        };
    },
    methods: {
        submitForm() {
        // console.log('Sending:', this.contact);
        alert("Message sent!");
        this.contact = { name: '', email: '', message: '' };
        }
    }
    }
</script>

<style scoped>

@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css";

.row {
  margin-top: 3em;
  margin-right: 0px;  
}


.col-md-6 {
  margin: 0;
  overflow: hidden;
}

.form-name{
  display: block;
  margin: 0;
  overflow: hidden;
  padding-bottom: 1.2em;
}

.name-input {
  width: 25vw;
  margin: auto;
  overflow: hidden;
}

.form-email{
  display: block;
  margin: 0;
  overflow: hidden;
  padding-bottom: 1.2em;
}

.email-input {
  width: 25vw;
  margin: auto;
  overflow: hidden;
}

.form-message{
  display: block;
  margin: 0;
  overflow: hidden;
  padding-bottom: 1.2em;
}

.message-input{
  width: 35vw;
  margin: auto;
  overflow: hidden;
}

.social-links{
  display: block;
  margin: 0;
  overflow: hidden;
  height: 50%;
}

/* Mobile */

@media screen and (max-width: 745px){

    .form{
      margin: 0;
    }

    .form-name{
      margin: auto;
    }

    .name-input {
      width: 50vw;
      margin: auto;
      overflow: hidden;
    }

    .email-input {
      width: 50vw;
      margin: auto;
      overflow: hidden;
    }

    .message-input {
      width: 75vw;
      margin: auto;
      overflow: hidden;
    }

    .social-links{
      margin-top: 1.5em;
      margin-bottom: 1.2em;
    }

    .social-contact{
      padding-bottom: 1.5em;
    }
}

</style>